import { Box, Stack, Typography } from "@mui/material";
import { Theme } from "../../../../Styles/GlobalTheme";
import SpeedMeter from "../../../../assets/icons/SpeedMeter.svg";

const NetworkHealthBanner = () => {
  return (
    <>
      <Stack
        direction={"row"}
        spacing={2}
        alignItems="center"
        my={3}
        p={2}
        sx={{
          backgroundColor: Theme.palette.customcolor.importantUpdatesBannerBg,
          boxShadow: `0px 0px 8px 0px ${Theme.palette.customcolor.bannerShadow}`,
          borderRadius: "8px",
        }}>
        <img src={SpeedMeter} alt="speed meter" />
        <Box>
          <Typography fontSize={20} fontWeight={700} color={Theme.palette.primary.main}>
            Your Ziply connection is working as expected.
          </Typography>
          <Typography fontSize={20} fontWeight={700} color={Theme.palette.primary.main}>
            Ziply Fiber has America's fastest internet with the lowest latency.
          </Typography>
        </Box>
      </Stack>
    </>
  );
};

export default NetworkHealthBanner;
